const Paypal = () => (
  <svg
    width={32}
    height={32}
    id="Layer_1"
    version="1.1"
    viewBox="0 0 514 514"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <>
      <circle cx="256" cy="256" r="242" fill="none" stroke="#D5D5D5" strokeWidth={17} />
      <g width={30} height={30}>
        <path
          d="M183.8,394.3c-21.3,0-42.6,0-64-0.1c-8.4,0-12.1-4.1-10.8-12.1c5.2-33.5,10.5-67.1,15.7-100.6   c5.1-32.4,10.1-64.8,15.3-97.1c4.4-27.8,8.9-55.6,13.5-83.4c1.5-8.9,7.7-13.8,16.8-13.8c36.6,0,73.3-0.4,109.9,0.1   c18.9,0.3,37.6,2.9,55.3,10.6c26.6,11.6,41.4,38.7,37.8,67.4c-0.4,2.9,0.3,6-1.4,8.7c-1-0.2-2-0.2-2.9-0.6   c-15-7.3-31.1-9.1-47.4-9.3c-29.5-0.4-59-0.1-88.5-0.1c-7.8,0-13.7,4.4-14.9,12c-1.9,12.7-4.1,25.5-6,38.2   c-2.9,19-6.2,37.8-8.9,56.8c-0.7,5.2-2.7,10.5-1.5,15.9c-0.7,2.2-1.7,4.2-2.1,6.6c-2,13.6-4.2,27.2-6.4,40.8   C190.2,354.3,187,374.3,183.8,394.3z"
          fill="#012D8A"
        />
        <path
          d="M183.8,394.3c3.2-20,6.4-40,9.6-59.9c2.2-13.6,4.4-27.2,6.4-40.8c0.4-2.4,1.4-4.4,2.1-6.6   c3.7-5.6,9-7.8,15.7-7.9c23.1-0.2,46.2,1.5,69-3.9c23.8-5.7,44.4-16.5,59.9-36c14.8-18.6,22.1-40.3,25.9-63.4   c18,8.9,26.8,24.3,28.4,43.3c2.2,25.2-3.7,49.3-16.3,71.2c-15.6,27.3-40.7,40.5-71,44.7c-10.3,1.4-20.8,2.1-31.2,1.9   c-8.4-0.2-13.2,4.2-14.5,12.6c-3.3,21.1-6.5,42.3-9.8,63.4c-2.1,13.6-3.6,20.8-23.3,20.1c-14.8-0.5-29.6-0.1-44.5-0.1   c-7.9,0-11.1-3.7-10.2-11.5C181,412.3,183.5,403.4,183.8,394.3z"
          fill="#019AE0"
        />
        <path
          d="M372.3,175.7c-3.7,23.1-11.1,44.8-25.9,63.4c-15.4,19.5-36.1,30.3-59.9,36c-22.8,5.5-46,3.7-69,3.9   c-6.7,0.1-12,2.3-15.7,7.9c-1.2-5.5,0.8-10.7,1.5-15.9c2.6-19,6-37.9,8.9-56.8c1.9-12.7,4.1-25.4,6-38.2c1.1-7.6,7-12,14.9-12   c29.5,0,59-0.3,88.5,0.1c16.2,0.2,32.4,2.1,47.4,9.3c0.9,0.4,1.9,0.4,2.9,0.6C372,174.6,372.2,175.1,372.3,175.7z"
          fill="#001F6B"
        />
      </g>
    </>
  </svg>
);

export default Paypal;
